import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import ReactToPrint from "react-to-print";

import "./JournalListing.scss";
import JournalEntries from "./journalEntries";
import AddToJournal from "./add/addToJournalPanel";
import JournalCards from "./journalCards";
import NutrientTable from "./nutrientTable";
import Hydration from "./hydration";
import FilterPanel from "../../../sharedComponents/filterPanel";
import SetGoals from "./setGoals";
// import Tooltip from "../../../sharedComponents/tooltip";

import { getNutritionGoals, getNutrionJournalEntries, getNutritionJournalSummary, resetField } from "../../../store/actions";

const NutritionJournal = ({
	nutritionGoals,
	getNutritionGoals,
	getNutrionJournalEntries,
	getNutritionJournalSummary,
	history,
	journalSummary,
	journal,
	toggleAddToJournal,
	resetField
}) => {
	const [startDate, setStartDate] = useState(new Date());
	const [updates, setUpdates] = useState(0);
	const componentRef = useRef(null);

	useEffect(() => {
		getNutritionGoals(`start_date=${moment().format("YYYY-MM-DD")}`);
	}, [getNutritionGoals]);

	useEffect(() => {
		const date = moment(startDate).format("YYYY-MM-DD");
		const queryString = `start_date=${date}&end_date=${date}`;
		getNutritionJournalSummary(queryString);
	}, [updates, startDate, getNutritionJournalSummary]);

	const [showGoalsPanel, setShowGoalsPanel] = useState(false);
	const courseOptions = [
		{ name: "Breakfast", id: "A" },
		{ name: "Snack 1", id: "B" },
		{ name: "Lunch", id: "C" },
		{ name: "Snack 2", id: "D" },
		{ name: "Dinner", id: "E" },
		{ name: "Other", id: "Z" }
	];
	const togglePanel = (event) => {
		resetField("NutritionJournal.toggleAddToJournal", event);
	};

	const handleChange = (date) => {
		setStartDate(date);
		const queryParam = `start_date=${moment(date).format("YYYY-MM-DD")}&end_date=${moment(date).format("YYYY-MM-DD")}`;
		getNutritionJournalSummary(queryParam);
		getNutrionJournalEntries(queryParam);
		getNutritionGoals(queryParam);
	};

	const onUpdateGoal = () => {
		getNutritionGoals();
		setShowGoalsPanel(false);
	};

	const renderGoalsPanel = () => {
		return (
			<FilterPanel show={showGoalsPanel} toggle={() => setShowGoalsPanel(!showGoalsPanel)} title="Set Goals" closeBtn>
				<SetGoals
					initialValues={
						nutritionGoals && nutritionGoals.id
							? nutritionGoals
							: {
								calories: 0,
								electrolyte: 0,
								fat: 0,
								fruits: 0,
								hydration: 0,
								misc: 0,
								protein_calories: 0,
								starch: 0,
								vegetable: 0,
								dairy: 0
							}
					}
					onUpdate={onUpdateGoal}
					toggle={() => setShowGoalsPanel(false)}
				/>
			</FilterPanel>
		);
	};

	return (
		<section className="page page-journal-listing page-nutrition-journal" ref={componentRef}>
			<div className="container">
				<div className="d-flex flex-row justify-content-between">
					<h3>Daily Journal</h3>
					<div>
						<DatePicker selected={startDate} onChange={handleChange} dateFormat="yyyy-MM-dd" maxDate={new Date()} />

						{moment(startDate).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD") ? (
							<button
								className="btn btn-primary-dark btn-ghost ml-3 align-top print-hidden"
								onClick={() => setShowGoalsPanel(true)}>
								Adjust Goal
							</button>
						) : (
								""
							)}
						{/* <ReactToPrint
							trigger={() => (
								<button className="btn btn-cell btn-light ml-2 print-hidden">
									<Tooltip content="Print">
										<i className="icon icon-print" />
									</Tooltip>
								</button>
							)}
							content={() => componentRef.current}
						/> */}
					</div>
				</div>

				<JournalCards data={journalSummary} goal={nutritionGoals} />

				<Hydration
					data={journalSummary}
					goal={nutritionGoals}
					getNutritionJournalSummary={getNutritionJournalSummary}
					date={startDate}
				/>

				<JournalEntries
					history={history}
					courseOptions={courseOptions}
					getNutrionJournalEntries={getNutrionJournalEntries}
					journal={journal}
					toggleAddToJournal={toggleAddToJournal}
					togglePanel={togglePanel}
					date={startDate}
					onUpdate={() => setUpdates(updates + 1)}
				/>
				<AddToJournal
					history={history}
					toggleAddToJournal={toggleAddToJournal}
					setToggleAddToJornal={togglePanel}
					courseOptions={courseOptions}
					date={startDate}
					onUpdate={() => setUpdates(updates + 1)}
				/>
				<NutrientTable date={startDate} nutrientData={journalSummary} />
			</div>
			{renderGoalsPanel()}
		</section>
	);
};

const mapStateToProps = (state) => ({
	nutritionGoals: get(state.NutritionJournal, "nutritionGoals", {}),
	journalSummary: get(state.NutritionJournal, "journalNutritionalSummary", {}),
	journal: get(state.NutritionJournal, "journalNutritionalEntries", []),
	toggleAddToJournal: get(state.NutritionJournal, "toggleAddToJournal", false)
});

const mapDispatchToProps = {
	getNutritionGoals,
	getNutritionJournalSummary,
	getNutrionJournalEntries,
	resetField
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(NutritionJournal);
